export default __webpack_public_path__ + "static/media/03.3084e4a4.jpg";